import {
    JOB_YARN_IN_OUT_REPORT_REQUEST,
    JOB_YARN_IN_OUT_REPORT_SUCCESS,
    JOB_YARN_IN_OUT_REPORT_FAILURE,
    JOB_YARN_IN_OUT_FILTER_REPORT_REQUEST,
    JOB_YARN_IN_OUT_FILTER_REPORT_SUCCESS,
    JOB_YARN_IN_OUT_FILTER_REPORT_FAILURE,
  } from "../types/job-yarn-in-out-report-types";
  
  const initialState = {
    jobYarnInOutReport: {},
    jobYarnInOutFilterReport: {},
    loading: false,
    error: null,
  };
  
  const jobYarnInOutReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case JOB_YARN_IN_OUT_REPORT_REQUEST: 
      case JOB_YARN_IN_OUT_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case JOB_YARN_IN_OUT_REPORT_SUCCESS: {
        return {
          ...state,
          jobYarnInOutReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case JOB_YARN_IN_OUT_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          jobYarnInOutFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case JOB_YARN_IN_OUT_REPORT_FAILURE: 
      case JOB_YARN_IN_OUT_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default jobYarnInOutReportReducer;
  